import { OrdinalLegend } from '../../../primitives/legend/OrdinalLegend';
import { useDonutData } from '../providers/data';
import { jsx as _jsx } from "react/jsx-runtime";
export function DonutLegend() {
  const {
    data,
    colorAccessor,
    labelAccessor,
    colorScale
  } = useDonutData();
  return /*#__PURE__*/_jsx(OrdinalLegend, {
    shape: "circle",
    data: data,
    colorScale: colorScale,
    colorAccessor: colorAccessor,
    labelAccessor: labelAccessor,
    justifyContent: 'center'
  });
}